var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dateTimeBody"},[_c('div',{staticClass:"mt-3 d-flex"},[_c('b-icon',{staticClass:"mr-4 h6",attrs:{"variant":"warning","icon":"calendar2-event-fill"}}),_c('p',{staticClass:"h6 mr-3"},[_vm._v("Date:")]),_c('p',{staticClass:"font-weight-bold ml-1 h6"},[_vm._v(_vm._s(_vm.formatDate(_vm.date)))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }